import React from 'react';
import { Navigate } from 'react-router-dom';
import LoadingSpinner from '../../components/common/LoadingSpinner';
import { startPath } from '../planner/labels';
import { useAuth } from './AuthContext';

/** Right after signing in: opens the start screen chosen in "A minha conta" (the same one as on Android). */
export default function StartRedirect() {
  const { settings, settingsLoaded } = useAuth();
  if (!settings && !settingsLoaded) return <LoadingSpinner />;
  return <Navigate to={startPath(settings?.startScreen)} replace />;
}
